import { ThemeComponentsInterface } from "./types/themeComponents.interface"

export const themeComponents = (): ThemeComponentsInterface => ({
    root: document.body,
    loader: document.getElementById('loader') as HTMLDivElement,
    brandName: document.getElementById('brand-name') as HTMLSpanElement,
    brandLogo: document.getElementById('brand-logo') as HTMLImageElement,
    brandBackground: document.getElementById('brand-background') as HTMLDivElement
})